import { useEffect } from 'react'
import { db } from '../lib/db'

/**
 * Dev-only keyboard shortcut (Ctrl+Shift+R) to reset app data.
 * Clears auth, IndexedDB, localStorage (preserving theme/language), then restarts.
 */
export function useDevReset() {
  useEffect(() => {
    if (import.meta.env.MODE !== 'development') return

    const handleDevReset = async (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key.toLowerCase() === 'r') {
        e.preventDefault()

        const isElectron = typeof window !== 'undefined' && 'api' in window

        if (isElectron && (window as any).api?.invoke) {
          try {
            try {
              const { supabase } = await import('../lib/supabase/client')
              if (supabase) await supabase.auth.signOut()
            } catch (_error) {
              // Silent error
            }

            db.delete().catch((err: unknown) =>
              console.error('[Dev] Error deleting IndexedDB:', err)
            )

            const mode = localStorage.getItem('mode')
            const language = localStorage.getItem('language')
            localStorage.clear()
            if (mode) localStorage.setItem('mode', mode)
            if (language) localStorage.setItem('language', language)
            sessionStorage.setItem('forceSetupPage', 'true')

            await (window as any).api.invoke('reset-window-settings')
            await (window as any).api.send('quit-app')
          } catch (error) {
            console.error('[Dev] Error during reset:', error)
          }
        } else {
          try {
            const { supabase } = await import('../lib/supabase/client')
            if (supabase) await supabase.auth.signOut()
          } catch (_error) {
            // Silent error
          }

          try {
            await db.delete()
          } catch (error) {
            console.error('[Dev] Error deleting IndexedDB:', error)
          }

          const mode = localStorage.getItem('mode')
          const language = localStorage.getItem('language')
          localStorage.clear()
          if (mode) localStorage.setItem('mode', mode)
          if (language) localStorage.setItem('language', language)

          window.location.href = '/'
        }
      }
    }

    window.addEventListener('keydown', handleDevReset)
    return () => window.removeEventListener('keydown', handleDevReset)
  }, [])
}
